module.exports = __webpack_public_path__ + "img/GXS.f481334c.svg";